import React, { Component } from 'react'
import {
  getStudentProgress,
  getSonePersonalDetails,
  getSoneDeclaration,
  updateSoneDeclaration,
} from '../../services/vu'
import {
  getStepByIndex,
  getStepIndexByUrl,
  updateDBStepProgress,
  updateStepProgress
} from '../../helpers/steps'
import { withRouter } from 'react-router-dom'
import AddToHomeScreen from '../tags/AddToHomeScreen'
import HelpText from '../tags/HelpText'
import Legalese from '../tags/Legalese'
import { getCourseId } from '../../helpers/course'
import {getAttributeCourseStaticInfo} from '../../helpers/enrolment'
import { getLegalTextForPage } from '../../services/reservoir'
import { differenceInSeconds } from 'date-fns'
import { getLastPageAccessTime } from '../../helpers/gtm'
import { getProperty } from '../../helpers/properties'
import Loading from "../tags/Loading";
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material'

class Start extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      name: '',
      school: '',
      location: '',
      courseId: '',
      courseAttemptStatus: '',
      courseSPKNo: '',
      availabilityYear: '',
      studyPeriodCode: '',
      legalText: '',
      sequenceNumber: '',
      obligation: false,
      attemptedToSubmit: false,
      submitting: false
    }
  }

  handleInitialState = (personalDetails, progress, legalTextResponse, studentDeclaration = null) => {
    const legalText =
      legalTextResponse.data &&
      legalTextResponse.data[0] &&
      legalTextResponse.data[0].attributes &&
      legalTextResponse.data[0].attributes.body &&
      legalTextResponse.data[0].attributes.body.value

    const processId = progress && progress.id ? progress.id : undefined

    this.trackUserData(processId)
    this.trackPageView(processId)

    this.setState({
      loading: false,
      sequenceNumber: studentDeclaration === null ? '' : studentDeclaration.sequenceNumber,
      legalText: legalText,
      name: personalDetails.preferredName || personalDetails.chosenFirstName || personalDetails.legalFirstName,
      school: getAttributeCourseStaticInfo('courseTitle'),
      courseId: getCourseId(),
      location: getAttributeCourseStaticInfo('locationDescription'),
      courseSPKNo: getAttributeCourseStaticInfo('courseSPKNo'),
      availabilityYear: getAttributeCourseStaticInfo('availabilityYear'),
      studyPeriodCode: getAttributeCourseStaticInfo('studyPeriodCode')
    })
  }

  componentDidMount() {
    Promise.all([getSonePersonalDetails(), getStudentProgress(getCourseId()), getLegalTextForPage('Submit')])
      .then(([personalDetails, progress, legalTextResponse]) => {
        getSoneDeclaration(getAttributeCourseStaticInfo('courseSPKNo')).then(studentDeclaration => {
          this.handleInitialState(personalDetails, progress, legalTextResponse, studentDeclaration)
        }).catch(error => {
          this.handleInitialState(personalDetails, progress, legalTextResponse)
        })
      })
  }

  trackUserData = processId => {
    const getApplicationModel = () => {
      switch (getAttributeCourseStaticInfo('blockCode')) {
        case '4WK':
        case '8WK':
          return 'Block'
        case '':
        case null:
          return undefined
        default:
          return 'Non-block'
      }
    }

    window.dataLayer.push({
      event: 'custom.service.user',
      content: {
        environment: getProperty('environment'),
        uiExperience: undefined
      },
      geo: {
        postcode: undefined,
        state: undefined,
        country: undefined
      },
      user: {
        emailHash: undefined,
        id: undefined,
        sessionId: undefined,
        sessionStart: undefined,
        type: 'Student'
      },
      data: {
        courseId: getCourseId(),
        applicationModel: getApplicationModel(),
        commencingStatus: getAttributeCourseStaticInfo('isCommencing'),
        cohort: getAttributeCourseStaticInfo('admissionCategory')
      },
      processId: processId
    })
  }

  trackPageView = processId => {
    const lastPageAccessTime = getLastPageAccessTime()
    const pageAccessTime = new Date()

    window.dataLayer.push({
      event: 'custom.form.step.view',
      group: 'Enrol',
      processId: processId,
      step: {
        sequence: 1,
        label: 'Start your enrolment',
        variation: undefined
      },
      info: {
        time: lastPageAccessTime
          ? differenceInSeconds(pageAccessTime, new Date(lastPageAccessTime))
          : undefined
      },
      data: {
        value: undefined,
        courseId: getCourseId()
      }
    })

    sessionStorage.setItem(
      'LAST_PAGE_ACCESS_TIME',
      JSON.stringify(pageAccessTime)
    )
  }

  handleFormSubmit = event => {
    //TODO change this
    event.preventDefault()

    this.setState({
      submitting: true
    })

    if (this.state.obligation) {
      const studentDeclarationRequest = {
        sequenceNumber: this.state.sequenceNumber,
        studentPermissionType: 'MYVUE',
        isStudentPermissionGranted: true,
        studyPackageNumber: getAttributeCourseStaticInfo('courseSPKNo'),
        courseAvailYear: getAttributeCourseStaticInfo('availabilityYear'),
        studyPeriod: getAttributeCourseStaticInfo('studyPeriodCode')
      }
      this.progressForm(studentDeclarationRequest)
    }
  }

  handleSubmitError = errorText => {
    this.setState({
      submitting: false
    })

    alert(errorText)
  }

  progressForm = studentDeclarationRequest => {
    //TODO change this
    updateSoneDeclaration(studentDeclarationRequest).then(
      response => {
        this.setState({
          submitting: false
        })

        const currentStepIndex = getStepIndexByUrl(this.props.location.pathname)

        updateStepProgress(currentStepIndex)
        updateDBStepProgress('start').then(
          progress => {
            const formStartedFlag = sessionStorage.getItem('FORM_STARTED')
            if (!formStartedFlag) {
              window.dataLayer.push({
                event: 'custom.form.start',
                group: 'Enrol',
                processId: progress.id,
                step: {
                  sequence: 1,
                  label: 'Start your enrolment',
                  variation: undefined
                },
                info: {
                  time: differenceInSeconds(new Date(), window.pageLoadTime)
                },
                data: {
                  value: undefined,
                  courseId: getCourseId()
                }
              })

              sessionStorage.setItem('FORM_STARTED', JSON.stringify(true))
            }

            this.props.history.push(getStepByIndex(currentStepIndex + 1).url)
          },
          () => {
            this.props.history.push(getStepByIndex(currentStepIndex + 1).url)
          }
        )
      },
      error => {
        //TODO change this
        this.handleSubmitError(error)
      }
    )
  }

  render() {
    if (this.state.loading) {
      return (
        <Loading />
      )
    }

    return (
      <form className="page page__home" onSubmit={this.handleFormSubmit}>
        <AddToHomeScreen />
        <div className="step-1">
          <p className="txt-lg" style={{paddingBottom: 20}}>
            Hi{' '}
            <span>{this.state.name}</span>,
            you are enrolling into:
          </p>
          <p className="txt-xl">
            {this.state.school}
            {this.state.courseId ? ` [${this.state.courseId}]` : null}
          </p>
          <p className="txt-lg">at</p>
          <p className="txt-xl" style={{marginBottom: 0}}>
            {this.state.location}
          </p>

          <p className="txt-md txt-light">(Your base campus)</p>
        </div>

        <div className="question-group">
          <HelpText tag="H3" text="Privacy Notice and Student Declaration" />

          <Legalese text={this.state.legalText} />
        </div>

        <div className="question-group">
          <FormGroup>
            <FormControlLabel 
              label="I have read the Privacy Notice and agree to the Student Declaration"
              control={
                <Checkbox
                  checked={this.state.obligation}
                  onChange={(event, isInputChecked) =>
                    this.setState({ obligation: isInputChecked })
                  }
                />
              } 
            />
          </FormGroup>
          
          {!this.state.obligation && this.state.attemptedToSubmit ? (
            <div className="form-error">
              Please agree to the Student Declaration before submitting.
            </div>
          ) : null}
        </div>

        <p className="txt-md" style={{textAlign: 'center', marginBottom: 30}}>
          Click 'Start' to commence your enrolment
        </p>

        <div className="row">
          <div className="col-xs-12 col-sm-offset-3 col-sm-6">
            <button
              className="btn btn-lg btn-primary enrol-start"
              type="submit"
              disabled={!this.state.obligation || this.state.submitting}
            >
              {this.state.submitting ? 'Submitting...' : 'Start'}
            </button>
          </div>
        </div>
      </form>
    )
  }
}

export default withRouter(Start)
